import { baseUrl, handleResponse, handleError, PutOptions, GetHeaders, DeleteHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/StockPrice";

export function getPriceHistory() {
    return fetch(`${apiUrl}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function createPrice(price) {
    return fetch(`${apiUrl}/Create`, PutOptions(price)).then(handleResponse).catch(handleError);
}

export function updatePrice(priceId, price) {
    return fetch(`${apiUrl}/${priceId}/Update`, PutOptions(price)).then(handleResponse).catch(handleError);
}

export function getPrice(priceId) {
    return fetch(`${apiUrl}/${priceId}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function deletePrice(priceId) {
    return fetch(`${apiUrl}/${priceId}/Delete`, DeleteHeaders()).then(handleResponse).catch(handleError);
}